import { Unidad } from "./unidad";
import { PrecioVenta } from "./precio-venta";
import { CostoVenta } from "./costo-venta";
import { Categoria } from "./categoria";
import { CuentaContable } from "./cuenta-contable";
import { Marca } from "./marca";
import { Modelo } from "./modelo";
//import { CampoAdicional } from "./campo-adicional";

export class Producto{
	constructor(
		public id: String = "",
		public codigo: String = "",
		public codigo_externo: String = "",
		public nombre: String = "",
		public nombreEquivalente: String = "",
		public descripcion: String = "",
		public ubicacion: String = "",
		public incluye_iva: boolean = false,
		public graba_iva: boolean = false,
		public impuesto_iva_id:String = "" ,
		public impuesto_ice_id:String = "" ,
		// public es_servicio: boolean = false,
		public if_uso_lote: boolean = null,
		public stock_maximo: String = "",
    	public stock_minimo: String = "",
		public ver_ecommerce: boolean = false,
		public sala_preparacion_id: String = "",
		public cuenta_ingreso_id: string = "",
		public cuenta_inventario_id: string = "",
		public cuenta_costo_gasto_id: string = "",
		public imagen: String = "",
		public es_vendido: boolean = false,
		public es_comprado: boolean = false,
		public categoria_id: String = "",
 		public subcategoria_id: String = null,
		public unidad_medida_id: String = "",
		public marca_id: String = null,
		public modelo_id: String = null,
		public empresa_id: String = "",
		public usuario_id: String = null,
		public precio:string = "",
		public costo:string = "",
		public inventario : Array<any>=[],
		public fecha_ingreso: any = null,

		public status: string = "",
		public tipo_producto_id = "",
		public unidadmedida: Unidad = new Unidad(),
		public categoria: Categoria = new Categoria(),
		public marca: Marca = new Marca(),
		public modelo: Modelo = new Modelo(),

		public cuentacontable:CuentaContable = new CuentaContable(),
		public precios: Array<PrecioVenta> = [],
		public costos: Array<CostoVenta> = [],
		public camposadicionales: any = {},
		public campoadicionalproducto: Array<any> = [],

		public preciosAdd: Array<any> = [],
	){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/producto.ts